var map = {
	"./Ahmad_Al_Shammari.png": 5569,
	"./Aidar_Kunbayev.png": 3015,
	"./Alexandru_Pirtac.png": 2398,
	"./Anastasia_Grigoras.png": 538,
	"./Aram_Grigorian.png": 6544,
	"./Azim_Choudry.png": 8636,
	"./Ben_Thomas.png": 4692,
	"./David_James.png": 1719,
	"./Dilshad_Muhammad.png": 4832,
	"./Dimitry_Zolotco.png": 2295,
	"./Dumitru_Bogaci.png": 9290,
	"./Elena_Mikhno.png": 922,
	"./Gabriela_Brunariova.png": 8197,
	"./Hassan_Kiani.png": 3343,
	"./Jalal_Kinana.png": 4703,
	"./Jamie_Lee_Brooker.png": 9312,
	"./Karim_Ahmed.png": 8798,
	"./Milana_Kapustina.png": 5697,
	"./Nadia_Chamor.png": 1656,
	"./Natascha_Louise_Ford.png": 7625,
	"./Otabek_Inogamov.png": 3905,
	"./Polina_Vodzinskaya.png": 6373,
	"./Ramesh_Srinivasan.png": 9277,
	"./Russell_Overy.png": 2956,
	"./Sam_Ayache.png": 1529,
	"./Shalabh_Goel.png": 5911,
	"./Shehryar_Malik.png": 1621,
	"./Tosin_Onadeko.png": 5661,
	"./Valeriia_Kravchenko.png": 3354,
	"./Varun_Saluja.png": 7633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2964;